import { buildRequest } from './request'

const request = buildRequest('/api/v1/front')

export type FeedbackFormFields = {
  region: string
  companyName: string
  name: string
  email: string
  discuss: string
  desc?: string
  attach?: string
}

export async function submitFeedbackFormData(data: FeedbackFormFields): Promise<Response> {
  let _data: FeedbackFormFields = data

  // 在请求头中添加 X-Region，传递地区信息
  const headerOptions = {
    'X-Region': _data.region || '',
  }
  const res = await request('/buy2', _data, headerOptions)
  return res
}

export function getFeedbackAPI(): string {
  return `/api/v1/front/buy2`
}
